import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Facebook, Twitter, Linkedin } from "lucide-react";
import { SITE, NAV } from "../data/content";
import { INDUSTRIES } from "../data/industries";
import { LOCATIONS } from "../data/locations";

export default function Footer() {
  return (
    <footer className="bg-[#080808] border-t border-white/5 mt-24" data-testid="site-footer">
      <div className="yv-container py-16 grid grid-cols-1 md:grid-cols-5 gap-10">
        <div className="md:col-span-2">
          <Link to="/" className="yv-logo-link inline-block">
            <img src="/yellow-logo.png" alt="Yellow Video Production" className="yv-logo-img" style={{ height: 36 }} />
          </Link>
          <p className="text-[var(--text-2)] mt-4 text-sm leading-relaxed">
            Liverpool's video production crew. From script to screen, covering the entire UK.
          </p>
          <div className="flex gap-3 mt-5">
            <a href={SITE.social.facebook} target="_blank" rel="noreferrer" className="p-2 bg-white/5 hover:bg-[var(--yellow)] hover:text-black rounded-full transition" data-testid="footer-fb">
              <Facebook size={16} />
            </a>
            <a href={SITE.social.twitter} target="_blank" rel="noreferrer" className="p-2 bg-white/5 hover:bg-[var(--yellow)] hover:text-black rounded-full transition" data-testid="footer-tw">
              <Twitter size={16} />
            </a>
            <a href={SITE.social.linkedin} target="_blank" rel="noreferrer" className="p-2 bg-white/5 hover:bg-[var(--yellow)] hover:text-black rounded-full transition" data-testid="footer-li">
              <Linkedin size={16} />
            </a>
          </div>
          <p className="yv-eyebrow mt-8 mb-3">Visit</p>
          <p className="text-white/70 text-sm leading-relaxed flex gap-2 items-start">
            <MapPin size={16} className="mt-1 text-[var(--yellow)] flex-shrink-0" />
            {SITE.address1}
          </p>
        </div>

        <div>
          <p className="yv-eyebrow mb-4">Services</p>
          <ul className="space-y-2 text-sm">
            {NAV.map((n) => (
              <li key={n.path}>
                <Link to={n.path} className="text-white/70 hover:text-[var(--yellow)] transition">
                  {n.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="yv-eyebrow mb-4">Industries</p>
          <ul className="space-y-2 text-sm">
            {INDUSTRIES.slice(0, 9).map((i) => (
              <li key={i.slug}>
                <Link to={`/${i.slug}`} className="text-white/70 hover:text-[var(--yellow)] transition">
                  {i.industry}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="yv-eyebrow mb-4">More</p>
          <ul className="space-y-2 text-sm">
            {INDUSTRIES.slice(9).map((i) => (
              <li key={i.slug}>
                <Link to={`/${i.slug}`} className="text-white/70 hover:text-[var(--yellow)] transition">
                  {i.industry}
                </Link>
              </li>
            ))}
            <li>
              <Link to="/blog" className="text-white/70 hover:text-[var(--yellow)] transition">
                Video Blog
              </Link>
            </li>
          </ul>
          <p className="yv-eyebrow mt-8 mb-4">Get In Touch</p>
          <a href={`tel:${SITE.phone.replace(/\s/g, "")}`} className="flex items-center gap-2 text-white/80 hover:text-[var(--yellow)] mb-2 text-sm">
            <Phone size={14} /> {SITE.phone}
          </a>
          <a href={`mailto:${SITE.email}`} className="flex items-center gap-2 text-white/80 hover:text-[var(--yellow)] text-sm break-all">
            <Mail size={14} /> {SITE.email}
          </a>
        </div>
      </div>

      {/* Areas We Cover — location landing pages */}
      <div className="border-t border-white/5">
        <div className="yv-container py-8">
          <p className="yv-eyebrow mb-4">Areas We Cover</p>
          <ul className="flex flex-wrap gap-x-6 gap-y-2 text-sm">
            {LOCATIONS.map((l) => (
              <li key={l.slug}>
                <Link
                  to={`/${l.slug}`}
                  className="text-white/70 hover:text-[var(--yellow)] transition"
                  data-testid={`footer-location-${l.slug}`}
                >
                  Video Production {l.city}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="yv-container py-6 text-xs text-white/40 flex flex-col md:flex-row justify-between gap-2">
          <p>© {new Date().getFullYear()} {SITE.fullName}, All rights reserved.</p>
          <p>Liverpool · UK Wide · From Script to Screen</p>
        </div>
      </div>
    </footer>
  );
}
